import 'slick-carousel';
import 'magnific-popup';

$(function() {
  $('.slider').slick({
    dots: false,
    pauseOnHover: false,
    pauseOnDotsHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    accessibility: false,
    prevArrow:'<div class="prev">PREV</div>',
    nextArrow:'<div class="next">NEXT</div>'
  });

  $(document).ready(function() {
    // チェック状態時に背景色を変更する
    $('.popup_area input:checked').closest('li').addClass('checked');
    if ($(window).width() < 750) {
      menuChecked();
    }
  });

  $(document).on('change', ".popup_area input[type='checkbox'], #main_page2 input[type='checkbox']", function() {
    if ($(this).is(":checked")) {
      $(this).closest('li').addClass('checked');
    } else {
      $(this).closest('li').removeClass('checked');
    }
  });

  $(document).on('click', ".slide_return", function() {
    returnPage();
  });
  $('.slide_return').on('click', function() {
    returnPage();
  });
  $(document).on('click', ".next_page", function() {
    var page = $(this).data('page');
    var cloneData = $('#page' + page).clone();
    $('#main_page2 div:last-child').empty();
    $('#main_page2 div:last-child').append(cloneData.attr('id', 'tmp'));
    $('#main_page2').data('now_page', page);
    $('.next').trigger('click');
  });

  $(window).on('resize', function() {
    if ($(window).width() > 750 && $('#main_page2 div:last-child').children().length > 0) {
      returnPage();
    }
  });

  // ---------------------
  // エリア選択
  // ---------------------

  // 活動地域選択モーダル「他の条件を選択ボタン」クリック時アクション
  $('.select-area-btn').click(function() {
    selectArea();
  });

  // 活動地域選択モーダル「この条件を検索ボタン」クリック時アクション
  $('.search-area-btn').click(function() {
    selectArea();
    $('#search_form').submit();
  });

  // エリア全選択
  $(document).on('click', ".region_select", function() {
    let idx = $(this).data('regionIdx');
    $('li.region-' + idx + '-area  input.area_ids').prop('checked', this.checked);
    // 背景色
    if (this.checked) {
      $('li.region-' + idx + '-area').addClass('checked');
    } else {
      $('li.region-' + idx + '-area').removeClass('checked');
    }
  });

  // エリア選択時処理
  $(document).on('click', ".area_ids", function() {
    let idx = $(this).data('regionIdx');
    toggleRegionCheck(idx);
  });

  // ---------------------
  // 業種選択
  // ---------------------

  // 活動地域選択モーダル「他の条件を選択ボタン」クリック時アクション
  $('.select-industry-btn').click(function() {
    selectIndustry();
  });

  // 業種選択モーダル「この条件を検索ボタン」クリック時アクション
  $('.search-industry-btn').click(function() {
    selectIndustry();
    $('#search_form').submit();
  });

  // ---------------------
  // 資格・免許選択
  // ---------------------

  // 資格・免許選択モーダル「他の条件を選択ボタン」クリック時アクション
  $('.select-licence-btn').click(function() {
    selectLicence();
  });

  // 資格・免許選択モーダル「この条件を検索ボタン」クリック時アクション
  $('.search-licence-btn').click(function() {
    selectLicence();
    $('#search_form').submit();
  });

  // ---------------------
  // 技能・講習選択
  // ---------------------

  // 技能・講習選択モーダル「他の条件を選択ボタン」クリック時アクション
  $('.select-skill-course-btn').click(function() {
    selecSkillCourse();
  });

  // 技能・講習選択モーダル「この条件を検索ボタン」クリック時アクション
  $('.search-skill-course-btn').click(function() {
    selecSkillCourse();
    $('#search_form').submit();
  });

  // ---------------------
  // マイ条件選択
  // ---------------------

  // マイ条件モーダル「選択」ボタンクリック時アクション（AJAX挿入後の要素にも対応）
  $(document).on('click', '#select-mysearch', function(e) {
    e.preventDefault();
    selecMysearch();
  });

  // マイ条件モーダル「削除」ボタンクリック時アクション（AJAX挿入後の要素にも対応）
  $(document).on('click', '#delete-mysearch', function(e) {
    e.preventDefault();
    deleteMysearch();
  });
});

function returnPage() {
  var page = $('#main_page2').data('now_page');
  $('#page' + page).empty();
  $('#page' + page).append($('#tmp').clone().children());
  menuChecked();
  $('#main_page2').data('now_page', null);
  $('.prev').trigger('click');
  $('.popup_area input:checked').closest('li').addClass('checked');
  $('#main_page2 div:last-child').empty();
}

function menuChecked () {
  $('#main_page1 ul li').removeClass("checked");
  $('#main_page1 ul li').each(function(index, element) {
    var checkedList = $('#page' + $(this).data('page')).find("input[type='checkbox']:checked");
    if (checkedList.length > 0) {
      $(this).addClass("checked");
    }
  });
}

// ---------------------
// エリア選択
// ---------------------

// 初期表示の全選択チェック判定
function initCheckebox() {
  $('.popup_area > ul').each(function() {
    let matchStr = $(this).attr('id').match(/\d+/)
    let idx = matchStr[0];
    toggleRegionCheck(idx);
  });
}

// エリア全選択チェックボックスの切り替え
function toggleRegionCheck(regionIdx) {
  let inputLength = $('.region-' + regionIdx + '-area' ).length;
  let checkedLength = $('.region-' + regionIdx + '-area .area_ids:checked').length;
  let selcter = '#region-' + regionIdx;
  if (inputLength === checkedLength) {
    $(selcter).prop('checked', 'checked');
    $('#region-' + regionIdx).parent().addClass('checked');
  } else {
    $(selcter).prop('checked', '');
    $('#region-' + regionIdx).parent().removeClass('checked');
  }
}

// エリア選択モーダルの選択内容をフォームに反映
function selectArea() {
  if ($('.area_ids:checked').length === 0 ) {
    $('#input_area_name').val("活動地域");
    $('#search_area_ids').val("");
  } else {
    let area_ids = [];
    let area_values = [];
    $('.area_ids:checked').each(function() {
      let area_id = $(this).data('areaId');
      area_ids.push(area_id);
      let label = $('#area-label' + area_id).text();
      area_values.push(label);
    });

    $('#search_area_ids').val(area_ids);
    $('#input_area_name').val(area_values.join("/"));
  }

  $('.mfp-close').click();
}

// ---------------------
// 業種選択
// ---------------------

// 業種選択モーダルの選択内容をフォームに反映
function selectIndustry() {
  let type_values = [];
  if ($('.business_type_ids:checked').length === 0) {
    $('#search_business_type_ids').val("");
  } else {
    let business_type_ids = [];
    $('.business_type_ids:checked').map(function() {
      let type_id = $(this).data('businessTypeId');
      business_type_ids.push(type_id);
      let label = $('#business-type-label' + type_id).text();
      type_values.push(label);
    });
    $('#search_business_type_ids').val(business_type_ids);
  }

  if (type_values.length > 0) {
    $('#input_industry_name').val(type_values.join("/"));
  } else {
    $('#input_industry_name').val("業種・職種");
  }
  $('.mfp-close').click();
}

// ---------------------
// 資格・免許選択
// ---------------------

// 資格・免許選択モーダルの選択内容をフォームに反映
function selectLicence() {
  if ($('.license_ids:checked').length === 0 ) {
    $('#input_qualification_name').val("");
    $('#search_license_ids').val("");
  } else {
    let license_ids = [];
    let qualification_values = [];
    $('.license_ids:checked').map(function() {
      let qualification_id = $(this).data('qualificationId');
      license_ids.push(qualification_id);
      let label = $('#qualification-label' + qualification_id).text();
      qualification_values.push(label);
    });
    $('#search_license_ids').val(license_ids);
    $('#input_qualification_name').val(qualification_values.join("/"));
  }
  $('.mfp-close').click();
}

// ---------------------
// 技能・講習選択
// ---------------------

// 技能・講習選択モーダルの選択内容をフォームに反映
function selecSkillCourse() {
  if ($('.skill_course_ids:checked').length === 0 ) {
    $('#input_skill_course_name').val("");
    $('#search_skill_ids').val("");
  } else {
    let skill_course_ids = [];
    let skill_course_values = [];
    $('.skill_course_ids:checked').map(function() {
      let skill_course_id = $(this).data('skill_courseId');
      skill_course_ids.push(skill_course_id);
      let label = $('#skill_course-label' + skill_course_id).text();
      skill_course_values.push(label);
    });
    $('#search_skill_ids').val(skill_course_ids);
    $('#input_skill_course_name').val(skill_course_values.join("/"));
  }
  $('.mfp-close').click();
}

// ---------------------
// マイ条件選択
// ---------------------

// マイ条件削除
function deleteMysearch() {
  let mysearch_id = $("input[name='customRadio1']:checked").val();
  $('.mfp-close').click();
  $('.message_area').removeClass('hide');
  $.ajax({ type: 'POST',
    url: '/delete_mysearch',
    data: {id: mysearch_id},
    dataType: "json",
    timespan: 1000,

  }).done(function(res) {
    if (res.result == 'OK') {
      $('#message').html(res.message)
    } else {
      $('#message').html('マイ検索条件を削除できませんでした。');
    }

  }).fail(function(res) {
    $('#message').html('エラーが発生しました。');
  });
}

// マイ条件で検索
function selecMysearch() {
  let mysearch_id = $("input[name='customRadio1']:checked").val();
  $('.mfp-close').click();
  location.href = '/search_members?my_search_condition_id=' + mysearch_id;
}
